import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.rag.retrieval');
import { OnInit, OnDestroy } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-rag-retrieval',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.rag.retrieval/view.scss */
:host {
  display: block;
}

.model-option {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 10px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  background: #fff;
}
.model-option.selected {
  border-color: #2563eb;
  color: #1d4ed8;
  background: #eff6ff;
}
.model-option input {
  accent-color: #2563eb;
}

.result-list {
  max-height: 1000px;
  overflow-y: auto;
}

.chunk-content[open] + .chunk-preview {
  display: none;
}`],
})
export class PageRagRetrievalComponent implements OnInit, OnDestroy {
    public question: string = '';
    public topK: number = 5;
    public mode: string = 'both';
    public loading: boolean = true;
    public running: boolean = false;
    public error: string = '';
    public overview: any = { models: [], documents: [], chunk_count: 0, document_count: 0 };
    public job: any = null;
    public embeddingJob: any = null;
    public operation: string = '';
    private destroyed: boolean = false;
    private requestId: number = 0;
    private overviewRequestId: number = 0;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadOverview();
    }

    public ngOnDestroy() {
        this.destroyed = true;
        this.requestId++;
    }

    public async loadOverview() {
        const requestId = ++this.overviewRequestId;
        this.loading = true;
        try {
            const response: any = await wiz.call('overview');
            if (!response || response.code !== 200) throw new Error(this.message(response));
            if (!this.destroyed && requestId === this.overviewRequestId) {
                const updated = response.data.overview;
                if (updated.corpus_hash !== this.overview.corpus_hash) {
                    this.job = null;
                    this.embeddingJob = null;
                }
                this.overview = updated;
            }
        } catch (error) {
            if (!this.destroyed) this.error = error.message || '검색 정보를 불러오지 못했습니다.';
        } finally {
            if (!this.destroyed && requestId === this.overviewRequestId) {
                this.loading = false;
                await this.service.render();
            }
        }
    }

    public selectedModels(): string[] {
        return this.mode === 'both' ? ['bge-m3', 'qwen3-embedding-0.6b'] : [this.mode];
    }

    public canSearch(): boolean {
        return !this.loading && !this.running && this.overview.chunk_count > 0
            && !!this.overview.corpus_hash
            && this.selectedModels().every(id => (this.overview.models || []).some(model =>
                model.id === id && model.available && model.index_ready))
            && this.question.trim().length > 0 && this.question.trim().length <= 2000
            && Number.isInteger(Number(this.topK)) && Number(this.topK) >= 1 && Number(this.topK) <= 100;
    }

    public async search() {
        if (this.running) return;
        if (!this.canSearch()) {
            this.error = '선택 모델의 문서 임베딩을 완료한 뒤 질문과 Top-K(1~100 정수)를 확인하세요.';
            return;
        }
        await this.runJob('search');
    }

    public canEmbed(): boolean {
        return !this.loading && !this.running && this.overview.chunk_count > 0
            && !!this.overview.corpus_hash
            && this.selectedModels().every(id => (this.overview.models || []).some(model =>
                model.id === id && model.available));
    }

    public async embed() {
        if (!this.canEmbed()) return;
        await this.runJob('embedding');
    }

    public async importLatest() {
        if (this.loading || this.running || !this.overview.latest) return;
        const requestId = ++this.requestId;
        this.running = true;
        this.operation = 'import';
        this.error = '';
        await this.service.render();
        try {
            const response: any = await wiz.call('import_chunks', { corpus_hash: this.overview.latest.hash });
            if (!response || response.code !== 200) throw new Error(this.message(response));
            if (this.destroyed || requestId !== this.requestId) return;
            this.job = null;
            this.embeddingJob = null;
            await this.loadOverview();
        } catch (error) {
            if (!this.destroyed && requestId === this.requestId) this.error = error.message || '청크를 가져오지 못했습니다.';
        } finally {
            if (!this.destroyed && requestId === this.requestId) {
                this.running = false;
                this.operation = '';
                await this.service.render();
            }
        }
    }

    public embeddingResult(modelId: string): any {
        return this.embeddingJob && this.embeddingJob.results.find(item => item.model_id === modelId);
    }

    private async runJob(kind: 'search' | 'embedding') {
        const requestId = ++this.requestId;
        const question = this.question.trim();
        const topK = Number(this.topK);
        const modelIds = this.selectedModels();
        const corpusHash = this.overview.corpus_hash;
        this.running = true;
        this.operation = kind;
        this.error = '';
        this.job = null;
        if (kind === 'embedding') this.embeddingJob = null;
        await this.service.render();
        try {
            const response: any = await wiz.call(kind === 'embedding' ? 'embed' : 'search', {
                question, top_k: topK, model_ids: JSON.stringify(modelIds), corpus_hash: corpusHash,
            });
            if (!response || response.code !== 202) throw new Error(this.message(response));
            if (this.destroyed || requestId !== this.requestId) return;
            let job = response.data.job;
            if (kind === 'embedding') this.embeddingJob = job;
            else this.job = job;
            await this.service.render();
            while (job.status === 'running') {
                await new Promise(resolve => setTimeout(resolve, 1200));
                if (this.destroyed || requestId !== this.requestId) return;
                const poll: any = await wiz.call('job_status', { job_id: job.job_id });
                if (!poll || poll.code !== 200) throw new Error(this.message(poll));
                if (this.destroyed || requestId !== this.requestId) return;
                job = poll.data.job;
                if (kind === 'embedding') this.embeddingJob = job;
                else this.job = job;
                await this.service.render();
            }
            await this.loadOverview();
        } catch (error) {
            if (!this.destroyed && requestId === this.requestId) {
                this.error = error.message || '작업 상태를 확인하지 못했습니다. 잠시 후 상태를 새로고침하세요.';
            }
        } finally {
            if (!this.destroyed && requestId === this.requestId) {
                this.running = false;
                this.operation = '';
                await this.service.render();
            }
        }
    }

    public results(): any[] {
        return this.job ? this.job.results : [];
    }

    public sameChunk(a: any, b: any): boolean {
        return a.document_id === b.document_id && a.chunk_id === b.chunk_id;
    }

    public otherRank(result: any, hit: any): number {
        const other = this.results().find(item => item.model_id !== result.model_id && item.status === 'complete');
        const found = other && other.hits.find(item => this.sameChunk(item, hit));
        return found ? found.rank : 0;
    }

    public comparisonReady(): boolean {
        return this.results().length === 2 && this.results().every(item => item.status === 'complete');
    }

    public overlapCount(): number {
        if (!this.comparisonReady()) return 0;
        const [left, right] = this.results();
        return left.hits.filter(hit => right.hits.some(other => this.sameChunk(hit, other))).length;
    }

    public preview(content: string): string {
        return content.length > 300 ? content.slice(0, 300) + '…' : content;
    }

    public pageLabel(page: any): string {
        const text = String(page == null ? '' : page).replace(/^Page\s+/i, '').trim();
        return text || '—';
    }

    private message(response: any): string {
        return (response && response.data && response.data.message)
            || (response && response.message) || '요청을 처리하지 못했습니다.';
    }
}

export default PageRagRetrievalComponent;